import { observable, computed } from "mobx";
import BrandActions from "./actions";
import { isDesktop, isLandscape } from "../../utils";

class BrandStoreClass extends BrandActions {
  constructor(props) {
    super();
    this.dataTemp = (props && props.data) || null;
    this.brandIdTemp = (props && props.brandId) || "nw";
    this.legalBrandNamesTemp = (props && props.legalBrandNames) || [];
    this.templateTypeTemp =
      (props && props.templateType) || "homeMasterTemplate";
    this.urlPrefixTemp = (props && props.urlPrefix) || "";
    this.previewModeTemp = (props && props.previewMode) || false;
  }
  @observable previewMode = this.previewModeTemp;
  @observable brandId = this.brandIdTemp;
  @observable legalBrandNames = this.legalBrandNamesTemp;
  @observable templateType = this.templateTypeTemp;
  @observable data = this.dataTemp;
  @observable urlPrefix = this.urlPrefixTemp;
  @computed
  get apiEndPoint() {
    return `${this.templateType}/${this.brandId}/${
      isDesktop || isLandscape ? "desktop" : "mobile"
    }${this.previewMode ? "/?cmsPreview=1" : ""}`;
  }
}

export default BrandStoreClass;



// WEBPACK FOOTER //
// ./src/stores/BrandStore/index.js